import { Box } from '@mui/material';
import { Table } from 'components/Table';
import { defaultColumns } from './defaultColumns';
import { useTableStore } from './selectTableStore';
import { useTableWithCheck } from './useTableWithCheck';
import { MaxItems } from 'components/PanelBox/MaxItems';

export const TableWithCheck = ({
  url = '/admin/videos?status=PUBLISHED&limit=10&offset=',
  title = '',
  listId,
  listKey = 'videoList',
  count: countMaxItems,
  limitExceeded,
}) => {
  const { data, page, count, setPage, isLoading, selectedItems } =
    useTableStore();

  const { getDataTable, onChangeSelected } = useTableWithCheck({
    url,
    title,
    listKey,
  });

  return (
    <Box
      sx={{
        height: '100%',
        display: 'grid',
        gridTemplateRows: `auto ${
          (selectedItems?.[listId]?.length ?? 0) <= 4 ? 'auto' : '200px'
        }`,
      }}>
      <Table.Root
        data-no-dnd="true"
        sx={{
          boxShadow: '0 0 0.25em #43475545, 0 0.25em 1em #5a7dbc0d',
          borderRadius: 0,
          display: 'grid',
        }}>
        <Table.Title>{title}</Table.Title>
        <Table.Filters
          onSubmit={filter => {
            setPage(0);
            getDataTable({ page: 0, filter });
          }}
        />
        <Table.Container>
          <Table.DataView
            isLoading={isLoading}
            selected={selectedItems?.[listId] || []}
            onChangeSelected={data => onChangeSelected(listId, data)}
            columns={defaultColumns}
            limitExceeded={limitExceeded}
            data={data}
          />
        </Table.Container>
        <Table.Pagination
          page={page}
          setPage={setPage}
          isLoading={isLoading}
          count={count}
          onChangePage={currentPage => {
            getDataTable({ page: currentPage });
            setPage(currentPage);
          }}
        />
      </Table.Root>
      <Box
        sx={{
          display: 'grid',
          gridTemplateRows: 'min-content',
        }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'auto auto',
            alignItems: 'center',
          }}>
          <Table.Title
            sx={{
              margin: 0,
              padding: 1,
              paddingLeft: 2.5,
              marginTop: 1,
            }}>
            Item(s) selecionado(s)
          </Table.Title>{' '}
          <Box sx={{ justifySelf: 'end', paddingRight: 2.5 }}>
            <MaxItems count={countMaxItems} />
          </Box>
        </Box>
        <Table.Root
          sx={{
            boxShadow: 'none',
            borderRadius: 0,
            display: 'block',
            overflow: 'auto',
          }}>
          <Table.Container>
            <Table.DataView
              showHeader={false}
              showEmpty={false}
              columns={[
                {
                  field: 'type',
                  align: 'left',
                  width: '60px',
                  height: '36px',
                  maxWidth: '60px',
                  render: value => {
                    const labels = {
                      VIDEO: 'Vídeo: ',
                      SERIES: 'Série: ',
                      COLLECTION: 'Coleção: ',
                    };

                    return labels[value] || '';
                  },
                },
                { field: 'title', align: 'left', height: '36px' },
              ]}
              data={selectedItems?.[listId] || []}
            />
          </Table.Container>
        </Table.Root>
      </Box>
    </Box>
  );
};
